module.exports = __webpack_public_path__ + "static/media/fiInactivityLight.4ed42328.svg";